"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MentionType = void 0;
var MentionType;
(function (MentionType) {
    MentionType["phone_number"] = "phone_number";
    MentionType["provider_name"] = "provider_name";
    MentionType["provider_state"] = "provider_state";
})(MentionType = exports.MentionType || (exports.MentionType = {}));
//# sourceMappingURL=typings.js.map